import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IdynamicFormItem } from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import { ResolvableComponent } from '@ispm/core/decorators/resolvable-component.decorator';
import { Rule } from '@ispm-client/modules/query-builder/models/query-builder-config';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { FormGroup } from '@angular/forms';
import get = Reflect.get;

export interface ParameterItemConfig {
  label: string;
  operator: IdynamicFormItem;
  value: IdynamicFormItem;
}

@Component({
  selector: 'query-parameter',
  templateUrl: './query-parameter.component.html',
  styleUrls: ['./query-parameter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@ResolvableComponent(null, 'QueryParameter')
export class QueryParameterComponent implements IWidgetItem {

  _widgetConfig: IdynamicFormItem;
  public data: { [key: string]: Rule};
  private _widgetFormInstance: FormGroup;
  set widgetFormInstance( widgetFormInstance: FormGroup) {
   this._widgetFormInstance = widgetFormInstance;
   this._widgetFormInstance.setValidators([this.updateValidity]);
   this._widgetFormInstance.updateValueAndValidity();
  }
  widgetUpdateValueCallback: (value) => void;
  config: ParameterItemConfig[];
  formConfig: any[];
  valueTypeDictionary: { [key: string]: string} = { };

  set widgetConfig(widgetConfig: IdynamicFormItem) {
    this._widgetConfig = widgetConfig;
    const widgetPayload = get(widgetConfig, 'widgetPayload', { });
    Object.assign(this, widgetPayload);
    this.valueTypeDictionary = this.formConfig.reduce((accMap, item) => {
      accMap[item.name] = item.valueType;
      return accMap;
    }, { });
  }

  set widgetData(widgetData: Rule[]) {
    this.data = (widgetData || [])
      .filter(property => (property.value || property.value === 0))
      .reduce((acc, property) => {
        acc[property.field] = property;
        return acc;
      }, { });
  }

  onValueChange(data, form) {
    const res = Object.keys(form)
      .filter(itemName => form[itemName] && (form[itemName].value || form[itemName].value === 0))
      .map(itemName => Object.assign({ field: itemName, valueType: this.valueTypeDictionary[itemName]}, form[itemName]))
      .reduce((rules, item) => {
        rules.push(item);
        return rules;
      }, []);

    this.widgetUpdateValueCallback(res);
  }

  private updateValidity(formControls) {
    if (formControls.value.rules && formControls.value.rules.length > 0) {
      return null;
    } else {
      return { 'notSelected': true};
    }
  }
}
